import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import styles from "./ReplyPreview.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faTimes, faReply } from "@fortawesome/free-solid-svg-icons";
import { formatMessageDate } from "utils/helpers";

const ReplyPreview = forwardRef(({ isReplying = false, message, onCancel }, ref) => {
  const content = (
    <>
      <span className={styles.name}>{isReplying ? "Replying to" : "Reply to"} {message.name}</span>
      <span className={styles.date}>{" "}from {formatMessageDate(message.date)}</span>
    </>
  );

  return (
    <div
      ref={ref}
      className={styles.container}
      style={!isReplying ? { borderLeft: "none" } : undefined}>
      <FontAwesomeIcon icon={faReply} className={styles.arrowIcon} onClick={() => { }} />
      <div className={styles.content}>
        <div className={styles.meta}>{content}</div>
        <div className={styles.previewMessage}>{message.message}</div>
      </div>
      <FontAwesomeIcon icon={faTimes} className={styles.closeIcon} onClick={onCancel}
        style={!isReplying ? { visibility: "hidden" } : undefined} />
    </div>
  );
});

ReplyPreview.propTypes = {
  message: PropTypes.string,
  isReplying: PropTypes.bool,
  onCancel: PropTypes.func,
};

export default ReplyPreview;
